<template>
  <div>
    <titulo-modulo titulo="Treinamentos" />
    <v-list class="mt-3">
      <template v-for="(tp, i) in tiposTreinamento">
        <v-list-item :key="i" :to="{ path: `/treinamentos/${tp.tipo}` }">
          <v-list-item-avatar tile>
            <v-icon size="30">{{tp.icon}}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="subtitle-1">{{ tp.descricao }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon class="float-right">mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="tp.tipo" v-if="tiposTreinamento.length > (i + 1)"></v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
export default {
  components: { TituloModulo },
  computed: {
    ...mapState("treinamento", ["tiposTreinamento"]),
  },
};
</script>

<style>
</style>